import { useState, useCallback } from 'react';

interface ErrorState {
  hasError: boolean;
  message: string | null;
  type: 'error' | 'warning' | null;
}

export const useErrorState = (initialState: ErrorState = { hasError: false, message: null, type: null }) => {
  const [errorState, setErrorState] = useState<ErrorState>(initialState);

  const setError = useCallback((message: string, type: 'error' | 'warning' = 'error') => {
    setErrorState({
      hasError: true,
      message,
      type,
    });
  }, []);

  const clearError = useCallback(() => {
    setErrorState({
      hasError: false,
      message: null,
      type: null,
    });
  }, []);

  const setWarning = useCallback((message: string) => {
    setError(message, 'warning');
  }, [setError]);

  return {
    error: errorState,
    setError,
    setWarning,
    clearError,
    hasError: errorState.hasError,
    errorMessage: errorState.message,
  };
};